<template>
  <div :class="calcClasses">
    <template v-for="addon in addons">
      <template v-if="addon.icon !== ''">
        <div :key="addon.id + addon.type" class="input-group-text">
          <i :class="addon.icon"></i>
        </div>
      </template>
      <template v-else>
        <div :key="addon.id + addon.type" class="input-group-text">
          {{ addon.text }}
        </div>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  addons: any[]
  type: string
}

const props = withDefaults(defineProps<Props>(), {
  addons: undefined,
  type: undefined
})

const calcClasses = computed(() => {
  if (props.type === 'pre') return 'input-group-prepend'
  if (props.type === 'post') return 'input-group-append'

  return ''
})
</script>
